import { useEffect, useState } from "react";
import http from "@/lib/api";
import { Panel } from "./AdminKit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function AdminSettings() {
  const [businessEmail, setBusinessEmail] = useState("");
  const [current, setCurrent] = useState("");
  const [newPass, setNewPass] = useState("");

  useEffect(() => {
    http.get("/v1/admin/settings").then((r) => setBusinessEmail(r.data.settings?.business_email || "")).catch(() => {});
  }, []);

  const saveSettings = async () => {
    try { await http.put("/v1/admin/settings", { settings: { business_email: businessEmail } }); toast.success("Настройки сохранены"); }
    catch { toast.error("Ошибка"); }
  };

  const changePassword = async () => {
    if (newPass.length < 6) { toast.error("Новый пароль минимум 6 символов"); return; }
    try { await http.post("/v1/admin/change-password", { current_password: current, new_password: newPass }); toast.success("Пароль изменён"); setCurrent(""); setNewPass(""); }
    catch (e) { toast.error(e?.response?.data?.detail || "Ошибка"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-settings">
      <h1 className="text-2xl font-bold text-white">Настройки</h1>
      <Panel title="Общие">
        <label className="text-sm text-slate-300">E-mail компании</label>
        <div className="flex gap-3 mt-1">
          <Input value={businessEmail} onChange={(e) => setBusinessEmail(e.target.value)} className="bg-slate-700 border-slate-600 text-white" data-testid="settings-email" />
          <Button className="bg-blue-600 hover:bg-blue-700 text-white" onClick={saveSettings} data-testid="settings-save">Сохранить</Button>
        </div>
      </Panel>
      <Panel title="Смена пароля">
        <div className="space-y-3 max-w-md">
          <div><label className="text-sm text-slate-300">Текущий пароль</label><Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1 bg-slate-700 border-slate-600 text-white" /></div>
          <div><label className="text-sm text-slate-300">Новый пароль</label><Input type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} className="mt-1 bg-slate-700 border-slate-600 text-white" /></div>
          <Button className="bg-blue-600 hover:bg-blue-700 text-white" onClick={changePassword} data-testid="password-change">Изменить пароль</Button>
        </div>
      </Panel>
    </div>
  );
}
